module.exports = __webpack_public_path__ + "static/media/Sko.0acddbf8.PNG";